// extracted by mini-css-extract-plugin
module.exports = {"arrows":"scroll-indicator-module--arrows--1zlA7","animate":"scroll-indicator-module--animate--1Te2T"};